import React from "react";
import { Col, Row, Typography } from "antd";
import { useGetMethodologyByIdQuery } from "../../../store/is/methodologyapi";

export const DisplayMethod = ({ methodNames }) => {

  return (
    <div>
      {methodNames.map((methodName) => (
        <Row key={methodName} align="middle" gutter={[8, 0]}>
          <Col>
            <Typography.Text style={{ fontSize: 14 }}>
              {methodName}
            </Typography.Text>
          </Col>
        </Row>
      ))}
    </div>
  );
};
